<template>
  <div class="footer-routes">
    <div class="title mb-3">
      {{ title }}
    </div>
    <slot></slot>
    <div class="routes-list">
      <template v-for="(link, i) in links">
        <a v-if="link.path" :key="i" :href="link.path" class="mb-2" :title="link.name">
          <font-awesome-icon :icon="icon" class="mr-2"></font-awesome-icon>
          <span>
            {{ link.text }}
          </span>
        </a>
        <router-link v-else :key="i" :to="link.route" class="mb-2">{{ link.name }}
          <font-awesome-icon :icon="icon" class="mr-2"></font-awesome-icon>
          <span>
            {{ link.text }}
          </span>
        </router-link>
      </template>
    </div>
  </div>
</template>


<script>
export default {
  name: "the-footer-routes",
  props: {
    title: String,
    section: String,
    icon: String,
    links: Array,
  },
};
</script>


<style lang="scss" scoped>
.footer-routes {
  color: $footer-font-color;
  font-size: 0.9rem;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
}

.routes-list a {
  color: $footer-font-color;
  display: block;
  text-decoration: none;
}

.routes-list a:hover {
  color: $footer-font-color;
}

.routes-list svg {
  color: $corp-color2;
}

.routes-list .highlight {
  color: $corp-color2;
}
</style>
